import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon } from 'lucide-react';
interface LanguageBarProps {
  language: 'en' | 'es';
  onLanguageChange: (lang: 'en' | 'es') => void;
}
export function LanguageBar({
  language,
  onLanguageChange
}: LanguageBarProps) {
  return <motion.div initial={{
    opacity: 0,
    y: -8
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: 0.3
  }} className="w-full bg-obsidian/80 backdrop-blur-sm border-b border-steel/40" data-id="element-184">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-end py-1.5 gap-2.5" data-id="element-185">
        <GlobeIcon size={13} className="text-gray-500" data-id="element-186" />
        <button onClick={() => onLanguageChange('en')} className={`font-inter text-xs tracking-wide transition-colors duration-200 ${language === 'en' ? 'text-gold font-medium' : 'text-gray-500 hover:text-gray-300'}`} data-id="element-187">
          English
        </button>
        <span className="text-gray-600 text-xs" data-id="element-188">|</span>
        <button onClick={() => onLanguageChange('es')} className={`font-inter text-xs tracking-wide transition-colors duration-200 ${language === 'es' ? 'text-gold font-medium' : 'text-gray-500 hover:text-gray-300'}`} data-id="element-189">
          Español
        </button>
      </div>
    </motion.div>;
}